import { HTMLAttributes } from 'react';

import { css } from '@compiled/react';

import { wacToken } from '@/libraries/design/foundations/index.ts';

import { useGenericTableVariant } from './generic-table-variant-context';

const rowCss = css({
	backgroundColor: wacToken('color.neutral.light0'),
	transition: 'background-color .5s',
	'&:hover': {
		backgroundColor: wacToken('color.neutral.light100'),
	},
});

const rowV2Css = css({
	height: 'calc(24px + 2 * 14px)',
	transition: 'none',
	borderBlockEnd: `1px solid ${wacToken('color.neutral.light300')}`,
	// No hover highlight
	'&:hover': {
		backgroundColor: wacToken('color.neutral.light0'),
	},
	'&:last-of-type': {
		borderBlockEnd: 'none',
	},
});

export const GenericTableRow = (props: HTMLAttributes<HTMLTableRowElement>) => {
	const { isV2 } = useGenericTableVariant();
	return <tr {...props} css={[rowCss, isV2 && rowV2Css]} />;
};
